import { PrimaryButton } from '@grays-npm/component-library';
import { useAuthData } from '../Auth';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { ApiError } from '../../services/apiError';
import {
  submitPromoteItem,
  PromoteItemReturn,
  PromoteItemRequest,
} from '../../services/promoteItem';
import { useModal } from '../../state/modal';
import { useCMSData } from '../../state/content-manager';
import { StyledBody, StyledHeading } from '../Modal/ModalStyles';

type PromoteItemProps = {
  itemName: string;
  lotSku: string;
  message?: string;
};

export const PromoteItem: React.FC<PromoteItemProps> = ({
  lotSku,
  itemName,
  message = 'The seller is enquiring about promoting their item '+ lotSku,
}) => {
  const userData = useAuthData();
  const { setModalProps } = useModal();
  const cmsData = useCMSData();
  const { subBody, title } = cmsData.modals.promote;

  const promoteItemMutation = useMutation<
    PromoteItemReturn,
    ApiError,
    PromoteItemRequest
  >(
    (promoteItemRequest) =>
      submitPromoteItem(promoteItemRequest, userData.token),
    {
      onSuccess: (data) => {
        setModalProps({
          onClose: () => {},
          isOpen: true,
          title: data.message,
        });
      },
      onError: (data) => {
        setModalProps({
          onClose: () => {},
          isOpen: true,
          title: data.message,
        });
      },
    }
  );

  const submitData: SubmitHandler<PromoteItemRequest> = () => {
    promoteItemMutation.mutate({ lotSku, itemName, message });
  };

  return (
    <div>
      <StyledHeading>{title}</StyledHeading>
      <StyledBody>
        {subBody && <span dangerouslySetInnerHTML={{ __html: subBody }}></span>}
        Item to promote: &nbsp;
        <strong>{itemName}</strong>
      </StyledBody>

      <PrimaryButton
        size="large"
        onClick={() => submitData({ lotSku, itemName, message })}
        isLoading={promoteItemMutation.isLoading}
      >
        Submit
      </PrimaryButton>
    </div>
  );
};
